type RedemptionPath = '/login' | '/signup' | '/forgot-password' | '/redeem';

/** Preserve the redemption token when moving between account and redemption pages. */
export const withRedemptionToken = (path: RedemptionPath, token?: string | null): string =>
  token ? `${path}?${new URLSearchParams({ token })}` : path;
